import type {
  GastosDiariosModalProps,
  UseGastosDiariosModalReturn,
} from "./types";

export const useGastosDiariosModal = ({
  setVerGastos,
}: GastosDiariosModalProps): UseGastosDiariosModalReturn => {
  const handleClose = () => {
    setVerGastos(false);
  };

  return {
    handleClose,
  };
};
